"use client";

import React from "react";

// Map loading placeholder for SSR
function MapPlaceholder({ mapheight = 300 }) {
  return (
    <div
      style={{
        height: mapheight,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f0f0f0",
        border: "1px solid #ddd",
      }}
    >
      <div>Loading map...</div>
    </div>
  );
}

class CityMapWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MapComponent: null,
      isClient: false,
      googleLoaded: false,
    };
    this.checkGoogleMapsInterval = null;
  }

  checkGoogleMapsLoaded = () => {
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      this.setState({ googleLoaded: true }, () => this.loadMapComponent());
      if (this.checkGoogleMapsInterval) {
        clearInterval(this.checkGoogleMapsInterval);
        this.checkGoogleMapsInterval = null;
      }
    }
  };

  loadMapComponent = () => {
    if (this.state.googleLoaded && !this.state.MapComponent) {
      import("./ModernCityMapComponent")
        .then((module) => {
          this.setState({ MapComponent: module.default });
        })
        .catch((error) => {
          console.error("Error loading city map component:", error);
        });
    }
  };

  componentDidMount() {
    this.setState({ isClient: true });

    // Check if Google Maps is already loaded (from global script)
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      this.setState({ googleLoaded: true }, () => this.loadMapComponent());
    } else {
      // Wait for Google Maps to load from global script
      this.checkGoogleMapsInterval = setInterval(
        this.checkGoogleMapsLoaded,
        200
      );
    }
  }

  componentWillUnmount() {
    if (this.checkGoogleMapsInterval) {
      clearInterval(this.checkGoogleMapsInterval);
    }
  }

  render() {
    const { lat, lng, cityname, statename, mapheight = 300 } = this.props;

    const { MapComponent, isClient, googleLoaded } = this.state;

    if (!isClient || !googleLoaded || !MapComponent) {
      return <MapPlaceholder mapheight={mapheight} />;
    }

    return (
      <div style={{ height: mapheight, width: "100%" }}>
        <MapComponent
          lat={lat}
          lng={lng}
          cityname={cityname}
          statename={statename}
          mapheight={mapheight}
        />
      </div>
    );
  }
}

export default CityMapWrapper;
